class InsightHighlightsAction {

  static REQUEST_INSIGHT_HIGHLIGHTS = 'REQUEST_INSIGHT_HIGHLIGHTS'
  static RECEIVE_INSIGHT_HIGHLIGHTS = 'RECEIVE_INSIGHT_HIGHLIGHTS'

  static requestInsightHightlights = () => ({
    type: InsightHighlightsAction.REQUEST_INSIGHT_HIGHLIGHTS
  })

  static receiveInsightHighlights = (highlights) => ({
    type: InsightHighlightsAction.RECEIVE_INSIGHT_HIGHLIGHTS,
    payload: {
      highlights: highlights
    }
  })
}

export default InsightHighlightsAction